<template>
  <ScChipSelect
    v-if="chipSelectOptions && chipSelectOptions.length > 0"
    v-bind:options="chipSelectOptions"
    v-bind:multiSelect="false"
    v-bind:labelProp="'chipLabel'"
    v-on:select="catchLoyalty($event)"/>
</template>

<script>
import { ScChipSelect } from 'smartcommerce-component-library'
import { OrderWizardActionTypes as actions } from '../../store/action-types'

export default {
  components: {
    ScChipSelect
  },

  props: {
    values: {
      type: Array
    }
  },

  created () {
    if (!this.values) {
      console.warn('missing loyalty values')
      return
    }
    const def = this.values.find(v => v.value === this.selectedLoyalty)
    if (!def) this.catchLoyalty(this.values[0])
  },

  computed: {
    selectedLoyalty: {
      get () {
        return this.$store.state.selectedLoyalty
      },
      set (val) {
        this.$store.dispatch(actions.UPDATE_LOYALTY, val)
      }
    },

    chipSelectOptions () {
      if (!this.values) return
      var opts = []
      this.values.forEach(v => {
        opts.push({
          chipLabel: this.$t(v.labelKey, { value: v.value }),
          value: v.value,
          isSelected: this.selectedLoyalty !== null && this.selectedLoyalty !== undefined && this.selectedLoyalty === v.value
        })
      })

      return opts
    }
  },

  methods: {
    catchLoyalty (event) {
      if (!event) return
      this.selectedLoyalty = event.value
      if (!this.$route.params.groupCode) {
        return
      }

      this.$ga && this.$ga.event({
        eventCategory: 'Package',
        eventAction: this.$route.params.groupCode,
        eventLabel: '',
        eventValue: this.selectedLoyalty
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .sc-chip-select-chip {
  transition: 0.3s;
}
</style>
